import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountUpModule } from 'ngx-countup';
import { ScoreboardColumnComponent } from './scoreboard-column.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';



@NgModule({
    declarations: [
        ScoreboardColumnComponent
    ],
    imports: [
        CommonModule,
        CountUpModule,
        SvgIconModule
    ],
    exports: [
        ScoreboardColumnComponent
    ]
})
export class ScoreboardColumnModule { }
